import {
    paymentsV2ActionTypes,
    paymentsV2MutationTypes,
} from '@/store/modules/payments_v2/types'
import paymentApi from '@/api/payments'
import api from '@/api/clients'
import { processClient, sortPayments } from '@/helpers/sort-payments.utils'

export default {
    [paymentsV2ActionTypes.FETCH_PAYMENT_TYPES]: async ({ commit }) => {
        try {
            const types = await paymentApi.getPaymentTypes()

            commit(paymentsV2MutationTypes.SET_PAYMENT_TYPES, types)
        } catch (e) {
            console.error('Error fetching payment types:', e)
        }
    },
    [paymentsV2ActionTypes.FETCH_BANK_CODES]: async ({ commit }) => {
        try {
            const banks = await paymentApi.getPaymentBanks()

            commit(paymentsV2MutationTypes.SET_BANK_CODES, banks)
        } catch (e) {
            console.error('Error fetching payment banks:', e)
        }
    },
    [paymentsV2ActionTypes.ADD_PAYMENT]: ({ commit }, paymentData) => {
        commit(paymentsV2MutationTypes.ADD_PAYMENT, paymentData)
    },
    [paymentsV2ActionTypes.UPDATE_PAYMENT]: (
        { commit },
        updatedPaymentData
    ) => {
        commit(paymentsV2MutationTypes.UPDATE_PAYMENT, updatedPaymentData)
    },
    [paymentsV2ActionTypes.REMOVE_PAYMENT]: ({ commit }, payment) => {
        commit(paymentsV2MutationTypes.REMOVE_PAYMENT, payment)
    },
    [paymentsV2ActionTypes.SET_PAYMENT_DESCRIPTION]: (
        { commit },
        description
    ) => {
        commit(paymentsV2MutationTypes.SET_PAYMENT_DESCRIPTION, description)
    },
    [paymentsV2ActionTypes.SET_CLIENT]: ({ commit, dispatch }, clientData) => {
        commit(paymentsV2MutationTypes.SET_CLIENT, clientData)
    },
    [paymentsV2ActionTypes.SET_COMMENTS]: ({ commit, dispatch }, comments) => {
        commit(paymentsV2MutationTypes.SET_COMMENTS, comments)
    },
    [paymentsV2ActionTypes.SET_VAT]: ({ commit, dispatch }, includesVAT) => {
        commit(paymentsV2MutationTypes.SET_VAT, includesVAT)
    },
    [paymentsV2ActionTypes.SET_INVOICE_AND_RECEIPT]: (
        { commit, dispatch },
        invoiceAndReceipt
    ) => {
        commit(
            paymentsV2MutationTypes.SET_INVOICE_AND_RECEIPT,
            invoiceAndReceipt
        )
    },
    [paymentsV2ActionTypes.FETCH_CLIENT_BY_WIG_ID]: async (
        { commit, dispatch },
        wigId
    ) => {
        try {
            commit(paymentsV2MutationTypes.SET_LOADING, true)

            const clientData = await api.clients.getClientByWigId(wigId)

            commit(paymentsV2MutationTypes.SET_CLIENT_BY_WIG_ID, clientData)
        } catch (e) {
            console.error('Error fetching client by wig id:', e)
        } finally {
            commit(paymentsV2MutationTypes.SET_LOADING, false)
        }
    },
    [paymentsV2ActionTypes.CONFIRM_PAYMENTS]: async (
        { state },
        { wigId, withRivhit }
    ) => {
        const sortedPayments = sortPayments(state.payments, state.comments)
        const processedPayments = {
            payments: { ...sortedPayments },
            description: state.description,
            include_vat: state.includesVAT,
            client: processClient(state.client),
            document_type: state.invoiceAndReceipt,
            is_sync_needed: withRivhit,
            wig_id: +wigId,
        }

        const res = await paymentApi.addNewPayment(processedPayments).catch()

        return res
    },
    [paymentsV2ActionTypes.RESET_STATE]: ({ commit }) => {
        commit(paymentsV2MutationTypes.RESET_STATE)
    },
}
